"use client";

import { useState } from "react";
import Link from "next/link";

export const inputClass =
  "mt-2 w-full rounded-xl border border-slate-200 bg-white px-4 py-3 text-sm text-slate-700 placeholder:text-slate-400 focus:border-violet-400 focus:outline-none dark:border-slate-700 dark:bg-[#0f172a] dark:text-slate-200";

export function OutputBox({ output }: { output: string }) {
  const [copied, setCopied] = useState(false);
  return (
    <div className="mt-4 rounded-xl border border-violet-200/80 bg-violet-50/60 p-4 dark:border-violet-800/60 dark:bg-violet-500/5">
      <div className="flex items-center justify-between">
        <p className="text-xs font-semibold uppercase tracking-wide text-violet-600 dark:text-violet-400">Result</p>
        <button
          type="button"
          onClick={() => {
            navigator.clipboard.writeText(output);
            setCopied(true);
            setTimeout(() => setCopied(false), 1500);
          }}
          className="text-xs font-medium text-violet-600 hover:underline dark:text-violet-400"
        >
          {copied ? "Copied ✓" : "Copy"}
        </button>
      </div>
      <p className="mt-2 whitespace-pre-wrap text-sm leading-relaxed text-slate-700 dark:text-slate-300">{output}</p>
    </div>
  );
}

export function ErrorBox({ message }: { message: string }) {
  return (
    <p className="mt-4 rounded-lg bg-rose-50 px-3 py-2 text-sm text-rose-600 dark:bg-rose-500/10 dark:text-rose-400">{message}</p>
  );
}

// Shown before the user hits the cap, so they know what to expect rather
// than only finding out from the error message after they're blocked.
export function FreeTrialNote() {
  return (
    <p className="mt-2 text-xs text-slate-500 dark:text-slate-400">
      🎁 1 free try on this tool — then{" "}
      <Link href="/pricing" className="font-medium text-violet-600 hover:underline dark:text-violet-400">
        Nohaya Pro
      </Link>{" "}
      for unlimited.
    </p>
  );
}
